import React from 'react';
import { IconProps } from '.';

const SvgHomeDashboard = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m17.058 11.419-1.14-.976-2.902 3.386-2.857-2-3.217 3.752 1.14.977 2.33-2.72 2.858 2 3.788-4.42Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1.498 1.502 10.805 2 12.117h1.75V22.25h16.5V12.117H22l.498-1.312L12 1.498Zm-8.024 9.119L12 3.502l8.024 7.115H18.75V20.75H5.25V10.617H3.976Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgHomeDashboard;
